<template>
  <div id="projectLists">
    <el-row class="header-row">
      <el-col :span="16">
        <h3 class="el-page-header">My Projects</h3>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>
            <clientNavSelector></clientNavSelector>
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: `/${currentClientId}/my-projects` }">My Projects</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: `/${currentClientId}/my-projects/${project.id}` }">{{ project.projectID }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="8">
        <rebuttalTraining style="float: right;"></rebuttalTraining>
      </el-col>
    </el-row>
    <div v-loading="loading" v-if="loading" style="height: 120px;" element-loading-spinner="nucleus-loader"></div>
    <div style="margin: 15px 0px 0px 0px;" v-show="!loading">
      <template v-if="hasMultiplePatTypes() === 0 || isInProgress()">
        <el-alert type="success" style="float: left; margin-bottom: 20px; font-size: 14px !important;" :closable="false">
          {{ projectStatusMessage }}
        </el-alert>
      </template>

      <template v-else>
        <el-alert v-if="project.appealAnsweredDate" type="warning" style="float: left; margin-bottom: 20px; font-size: 14px !important; font-weight: bold;" :closable="false"> Rebuttals Completed on {{ formatDate(project.appealAnsweredDate) }}. All Rebuttal Responses are locked. </el-alert>
        <template v-if="hasMultiplePatTypes() === 1">
          <h4 class="headerWithBorder">Details {{ getRecordCount() }}</h4>

          <coderProjectHeader :loading="loading" :projectStatistics="singlePatTypeLabel"> </coderProjectHeader>

          <div v-if="project.hasIPRecords">
            <el-tabs class="tab">
              <el-tab-pane v-if="rebuttalManager()">
                <span slot="label"><i class="mdi mdi-account-box-outline reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Rebuttal Tracking</span>
                <rebuttalTracking recordType="IP" :projectId="project.id"></rebuttalTracking>
              </el-tab-pane>
              <el-tab-pane>
                <span slot="label"><i class="mdi mdi-book-multiple reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Charts</span>
                <coderInpatientList></coderInpatientList>
              </el-tab-pane>
              <el-tab-pane v-if="!hideNucleusRebuttalDashboards()">
                <span slot="label"><i class="mdi mdi-airplay" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Dashboard</span>
                <span id="reviewDashboard"></span>
                <ReviewDashboardInpatient ref="reviewDashIP" @expandCollapse="false" :isClosed="false" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="false" :dateRange="dateRange"> </ReviewDashboardInpatient>
              </el-tab-pane>
            </el-tabs>
          </div>

          <div v-if="project.hasOPRecords">
            <el-tabs class="tab">
              <el-tab-pane v-if="rebuttalManager()">
                <span slot="label"><i class="mdi mdi-account-box-outline reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Rebuttal Tracking</span>
                <rebuttalTracking recordType="OP" :projectId="project.id"></rebuttalTracking>
              </el-tab-pane>
              <el-tab-pane>
                <span slot="label"><i class="mdi mdi-book-multiple reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Charts</span>
                <coderOutpatientList></coderOutpatientList>
              </el-tab-pane>
              <el-tab-pane v-if="!hideNucleusRebuttalDashboards()">
                <span slot="label"><i class="mdi mdi-airplay" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Dashboard</span>
                <span id="reviewDashboard"></span>
                <ReviewDashboardOutpatient ref="reviewDashOP" @expandCollapse="false" :isClosed="false" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="false" :dateRange="dateRange"></ReviewDashboardOutpatient>
              </el-tab-pane>
            </el-tabs>
          </div>

          <div v-if="project.hasAMBRecords">
            <el-tabs class="tab">
              <el-tab-pane v-if="rebuttalManager()">
                <span slot="label"><i class="mdi mdi-account-box-outline reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Rebuttal Tracking</span>
                <rebuttalTracking recordType="AMB" :projectId="project.id"></rebuttalTracking>
              </el-tab-pane>
              <el-tab-pane>
                <span slot="label"><i class="mdi mdi-book-multiple reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Charts</span>
                <coderAmbulatoryList></coderAmbulatoryList>
              </el-tab-pane>
              <el-tab-pane v-if="!hideNucleusRebuttalDashboards()">
                <span slot="label"><i class="mdi mdi-airplay" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Dashboard</span>
                <span id="reviewDashboard"></span>
                <ReviewDashboardAmbulatory ref="reviewDashAmb" @expandCollapse="false" :isClosed="false" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="false" :dateRange="dateRange"></ReviewDashboardAmbulatory>
              </el-tab-pane>
            </el-tabs>
          </div>

          <div v-if="project.hasPRORecords">
            <el-tabs class="tab">
              <el-tab-pane v-if="rebuttalManager()">
                <span slot="label"><i class="mdi mdi-account-box-outline reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Rebuttal Tracking</span>
                <rebuttalTracking recordType="PRO" :projectId="project.id"></rebuttalTracking>
              </el-tab-pane>
              <el-tab-pane>
                <span slot="label"><i class="mdi mdi-book-multiple reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Charts</span>
                <coderProList></coderProList>
              </el-tab-pane>
              <el-tab-pane v-if="!hideNucleusRebuttalDashboards()">
                <span slot="label"><i class="mdi mdi-airplay" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Dashboard</span>
                <span id="reviewDashboard"></span>
                <ReviewDashboardProfee ref="reviewDashPro" @expandCollapse="false" :isClosed="false" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="false" :dateRange="dateRange"></ReviewDashboardProfee>
              </el-tab-pane>
            </el-tabs>
          </div>
        </template>
        <template v-if="hasMultiplePatTypes() > 1">
          <div style="height: 100%; display: grid; float: left;">
            <el-tabs style="height: 100%;" ref="patientTabs" class="patientTabs" type="border-card" tab-position="left" v-model="activePatientTab" @tab-click="handlePatientTabs">
              <el-tab-pane v-if="project.hasIPRecords" name="ip">
                <span slot="label"
                  >Inpatient <el-tag style="float: right; margin: 9px 0px 0px 10px;" size="mini">{{ project.ipCount }}</el-tag></span
                >
                <el-row :gutter="20">
                  <h4 class="headerWithBorder">Details - {{ project.ipCount }} Inpatient Records</h4>

                  <coderProjectHeader :loading="loading" :projectStatistics="'ip'"> </coderProjectHeader>
                </el-row>
                <el-tabs class="tab">
                  <el-tab-pane v-if="rebuttalManager()">
                    <span slot="label"><i class="mdi mdi-account-box-outline reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Rebuttal Tracking</span>
                    <rebuttalTracking recordType="IP" :projectId="project.id"></rebuttalTracking>
                  </el-tab-pane>
                  <el-tab-pane>
                    <span slot="label"><i class="mdi mdi-book-multiple reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Charts</span>
                    <coderInpatientList ref="ipList"></coderInpatientList>
                  </el-tab-pane>
                  <el-tab-pane v-if="!hideNucleusRebuttalDashboards()">
                    <span slot="label"><i class="mdi mdi-airplay" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Dashboard</span>
                    <span id="reviewDashboard"></span>
                    <ReviewDashboardInpatient ref="reviewDashIP" @expandCollapse="false" :isClosed="false" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="false" :dateRange="dateRange"> </ReviewDashboardInpatient>
                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
              <el-tab-pane v-if="project.hasOPRecords" name="op">
                <span slot="label"
                  >Outpatient <el-tag style="float: right; margin: 9px 0px 0px 10px;" size="mini">{{ project.opCount }}</el-tag>
                </span>
                <el-row :gutter="20">
                  <h4 class="headerWithBorder">Details - {{ project.opCount }} Outpatient Records</h4>

                  <coderProjectHeader :loading="loading" :projectStatistics="'op'"> </coderProjectHeader>
                </el-row>
                <el-tabs class="tab">
                  <el-tab-pane v-if="rebuttalManager()">
                    <span slot="label"><i class="mdi mdi-account-box-outline reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Rebuttal Tracking</span>
                    <rebuttalTracking recordType="OP" :projectId="project.id"></rebuttalTracking>
                  </el-tab-pane>
                  <el-tab-pane>
                    <span slot="label"><i class="mdi mdi-book-multiple reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Charts</span>
                    <coderOutpatientList ref="opList"></coderOutpatientList>
                  </el-tab-pane>
                  <el-tab-pane v-if="!hideNucleusRebuttalDashboards()">
                    <span slot="label"><i class="mdi mdi-airplay" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Dashboard</span>
                    <span id="reviewDashboard"></span>
                    <ReviewDashboardOutpatient ref="reviewDashOP" @expandCollapse="false" :isClosed="false" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="false" :dateRange="dateRange"></ReviewDashboardOutpatient>
                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
              <el-tab-pane v-if="project.hasAMBRecords" name="amb">
                <span slot="label"
                  >Ambulatory <el-tag style="float: right; margin: 9px 0px 0px 10px;" size="mini">{{ project.ambCount }}</el-tag></span
                >
                <el-row :gutter="20">
                  <h4 class="headerWithBorder">Details - {{ project.ambCount }} Ambulatory Records</h4>

                  <coderProjectHeader :loading="loading" :projectStatistics="'amb'"> </coderProjectHeader>
                </el-row>
                <el-tabs class="tab">
                  <el-tab-pane v-if="rebuttalManager()">
                    <span slot="label"><i class="mdi mdi-account-box-outline reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Rebuttal Tracking</span>
                    <rebuttalTracking recordType="ASC" :projectId="project.id"></rebuttalTracking>
                  </el-tab-pane>
                  <el-tab-pane>
                    <span slot="label"><i class="mdi mdi-book-multiple reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Charts</span>
                    <coderAmbulatoryList ref="ambList"></coderAmbulatoryList>
                  </el-tab-pane>
                  <el-tab-pane v-if="!hideNucleusRebuttalDashboards()">
                    <span slot="label"><i class="mdi mdi-airplay" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Dashboard</span>
                    <span id="reviewDashboard"></span>
                    <ReviewDashboardAmbulatory ref="reviewDashAmb" @expandCollapse="false" :isClosed="false" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="false" :dateRange="dateRange"></ReviewDashboardAmbulatory>
                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
              <el-tab-pane v-if="project.hasPRORecords" name="pro">
                <span slot="label"
                  >Professional Fee <el-tag style="float: right; margin: 9px 0px 0px 10px;" size="mini">{{ project.proCount }}</el-tag></span
                >
                <el-row :gutter="20">
                  <h4 class="headerWithBorder">Details - {{ project.proCount }} Professional Fee Records</h4>

                  <coderProjectHeader :loading="loading"> </coderProjectHeader>
                </el-row>
                <el-tabs class="tab">
                  <el-tab-pane v-if="rebuttalManager()">
                    <span slot="label"><i class="mdi mdi-account-box-outline reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Rebuttal Tracking</span>
                    <rebuttalTracking recordType="PRO" :projectId="project.id"></rebuttalTracking>
                  </el-tab-pane>
                  <el-tab-pane>
                    <span slot="label"><i class="mdi mdi-book-multiple reviewIcon" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Charts</span>
                    <coderProList ref="proList" :projectStatistics="'pro'"></coderProList>
                  </el-tab-pane>
                  <el-tab-pane v-if="!hideNucleusRebuttalDashboards()">
                    <span slot="label"><i class="mdi mdi-airplay" style="font-size: 16px; margin: 0px 5px 0px 0px;"></i> Dashboard</span>
                    <span id="reviewDashboard"></span>
                    <ReviewDashboardProfee ref="reviewDashPro" @expandCollapse="false" :isClosed="false" :bedSizeDropdown="bedSizeDropdown" @comparisonLoading="false" :dateRange="dateRange"></ReviewDashboardProfee>
                  </el-tab-pane>
                </el-tabs>
              </el-tab-pane>
            </el-tabs>
          </div>
        </template>
      </template>
    </div>

    <el-popover ref="taskHistoryPopover" :title="`Change History for ${selectedTaskHistoryTask.name}`" placement="right" width="600" @after-enter="handleHidePopOver('taskHistoryPopover')">
      <div style="align-items: center;">
        <v-client-table id="taskTable" class="hiaTable" :columns="['event', 'date', 'user']" :data="selectedTaskHistoryRows" :options="taskTableOptions"> </v-client-table>
      </div>
    </el-popover>
    <el-popover ref="savePopover" style="word-break: normal;" placement="bottom" title="" width="300" trigger="manual" popper-class="popover" :content="savePopoverContent" @after-enter="handleHidePopOver('savePopover')"> </el-popover>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import coderInpatientList from '@/views/MyProjects/inpatient/coderInpatientList'
import coderOutpatientList from '@/views/MyProjects/outpatient/coderOutpatientList'
import coderAmbulatoryList from '@/views/MyProjects/ambulatory/coderAmbulatoryList'
import coderProList from '@/views/MyProjects/pro/coderProList'
import coderProjectHeader from '@/views/MyProjects/coderProjectHeader'
import rebuttalTracking from '@/views/MyProjects/rebuttalTracking'
import dateHelper from '@/mixins/date-helper'
// import dashboards from '@/views/reports/dashboards'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import { format, parseISO } from 'date-fns'
import ReviewDashboardInpatient from '@/views/Dashboards/ReviewDashboardInpatient'
import ReviewDashboardOutpatient from '@/views/Dashboards/ReviewDashboardOutpatient'
import ReviewDashboardAmbulatory from '@/views/Dashboards/ReviewDashboardAmbulatory'
import ReviewDashboardProfee from '@/views/Dashboards/ReviewDashboardProfee'
import rebuttalTraining from '@/views/MyProjects/rebuttalTraining.vue'

const { mapFields } = createHelpers({
  getterType: 'myProjects/getField',
  mutationType: 'myProjects/updateField'
})

export default {
  name: 'coderProject',
  mixins: [dateHelper, HiaAuthorization],
  data() {
    return {
      activePatientTab: '',
      singlePatTypeLabel: '',
      dateRange: [],
      format: format,
      parseISO: parseISO,
      activeName: '',
      activeNames: ['tracking', 'dashboard'],
      statusFilters: [3, 4],
      backupStatusFilters: [],
      backupIdentifierSelectionsArray: [],
      deactivated: false,
      loading: false,
      selectedProcess: null,
      selectedTaskHistoryRows: [],
      selectedTaskHistoryTask: {},
      dropdownsNeeded: ['clients', 'projectIdentifiers', 'projectTypes', 'coders', 'consultants', 'codeTypes', 'outpatientGroupers', 'reviewStatus', 'projectStatus', 'projectProcesses'],
      localdateRange: [],
      taskTableOptions: {
        filterable: false,
        filterByColumn: false,
        sortable: ['name'],
        columnsClasses: {
          task: 'taskCol',
          taskDate: 'taskDateCol',
          isNA: 'isNACol',
          modifiedBy: 'modifiedByCol',
          modifiedDate: 'modifiedDateCol'
        },
        headings: {
          taskDate: 'Task Date',
          modifiedBy: 'Modified By',
          isNA: 'N/A',
          modifiedDate: 'Modified Date'
        },
        sortIcon: { is: 'none' }
      },
      savePopoverContent: '',
      bedSizeDropdown: [{ key: '0 - 99', value: '0 - 99' }, { key: '100 - 199', value: '100 - 199' }, { key: '200 - 299', value: '200 - 299' }, { key: '300 - 500', value: '300 - 500' }, { key: '500+', value: '500+' }]
    }
  },
  methods: {
    ...mapActions('inpatientReviews/', ['GET_IPLIST_PROJECT_STATS']),
    ...mapActions('outpatientReviews/', ['GET_OPLIST_PROJECT_STATS']),
    ...mapActions('proReviews/', ['GET_PROLIST_PROJECT_STATS']),
    // ...mapActions('dropdowns/', ['GET_DROPDOWNS']),
    ...mapActions('myProjects/', ['LOAD_PROJECT', 'UPDATE_PROJECT', 'PUT_PROJECT_TASK', 'GET_PROJECT_DASHBOARD_IDS_STATS']),
    ...mapMutations('myProjects/', ['SET_PROJECTPK', 'SET_PROJECT']),
    ...mapActions('dashboard/', ['GET_DASHBOARD_PROJECTS', 'POST_REVIEW_DASHBOARD_ALL', 'POST_DASHBOARD_PROJECTS_MULTIPLE', 'GET_INTERIM_SUMMARY_PDF_URL']),
    ...mapMutations('dashboard', ['SET_SELECTED_PROJECTS']),
    getUserById(userId) {
      let user = this.dropdowns.consultants.list.find(f => f.key === userId)
      if (user) {
        user = user.value
        return user
      }
      return user
    },
    getProjectStatusLabel(status) {
      switch (status) {
        case 'Not Started':
          return 'Not Started (No Chart Reviewed)'
        case 'Project Ready':
          return 'Project Ready (Charts Imported)'
        case 'In Progress':
          return 'In Progress (First Chart Reviewed)'
        default:
          return status
      }
    },
    initialize() {
      window.document.title = 'Project'
      this.loading = true
      const payload = {
        id: this.$route.params.id,
        statusFilters: this.statusFilters,
        isCoding: true
      }

      // we need to make sure that we load the project before we render the associated tabs for IP, OP and Pro Lists
      // because of the way the watchers work inside those components

      Promise.all([this.LOAD_PROJECT(payload)]).then(response => {
        this.selectedProcess = this.project.processId
        if (!this.selectedProcess) {
          this.activeNames = this.activeNames.filter(x => x !== 'tracking')
        }
        this.$nextTick(() => {
          this.SET_SELECTED_PROJECTS([this.project])
          this.dateRange[0] = format(new Date(this.project.startDate), 'MM-dd-yyyy')
          this.dateRange[1] = format(new Date(this.project.endDate), 'MM-dd-yyyy')
          this.getReviewDashboardData()
          this.setActivePatientTab()
          this.loading = false
        })
      })
    },
    handleTabClick(e) {
      if (this.activeName === 'details') {
        const payload = {
          id: this.id,
          statusFilters: this.statusFilters,
          projectTypeName: this.project.projectTypeName,
          isCoding: true
        }
        this.GET_PROJECT_DASHBOARD_IDS_STATS(payload)
      }
    },
    async putProjectTask(updatedRow) {
      const index = this.project.projectTasks.findIndex(x => x.projectsTaskId === updatedRow.projectsTaskId)

      if (updatedRow.isNA && updatedRow.taskDate) {
        try {
          await this.$confirm('This will clear the existing Task Date. Continue?', 'Warning', { confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning' })
          updatedRow.taskDate = null
        } catch (e) {
          updatedRow.isNA = !updatedRow.isNA
          this.$set(this.project.projectTasks, index, updatedRow)
          return
        }
      }

      // we found a bug where element's datepicker X button calls this method twice
      // so the following code prevents the network call from happening twice
      const existingRow = this.project.projectTasks[index]
      if (JSON.stringify(updatedRow) === JSON.stringify(existingRow)) {
        return
      }

      this.$set(this.project.projectTasks, index, updatedRow)

      try {
        await this.PUT_PROJECT_TASK(updatedRow)
        this.$message({
          message: 'Project Task Saved',
          type: 'success'
        })
      } catch (err) {
        this.$message({
          message: 'Error Editing Project Task',
          type: 'error'
        })
      }
    },
    setActiveTabName() {
      // because of keep alive, we may need to reset the active tab if the user goes from in IP project to an OP or Pro project
      if (this.activeName !== 'details' && this.activeName !== this.project.projectTypeName) {
        this.activeName = 'details'
      }
      if (this.$route.query.type) {
        if (this.project.projectTypeName === 'Ambulatory') {
          this.activeName = 'Ambulatory'
        } else {
          this.activeName = this.$route.query.type
        }
      }
    },
    async updateProjectProcess(val) {
      this.project.processId = parseInt(val)
      await this.updateProject('taskTemplate')
      this.selectedProcess = this.project.processId
    },
    async updateProject(field) {
      try {
        if (field === 'projectStatusId') {
          switch (this.project.projectStatusId) {
            case 1:
              this.project.projectColor = '#003169'
              break
            case 2:
              this.project.projectColor = '#fec41f'
              break
            case 3:
              this.project.projectColor = '#63b344'
              break
          }
        }
        await this.UPDATE_PROJECT(this.project)

        if (this.project.processId && !this.activeNames.some(x => x === 'tracking')) {
          this.activeNames.push('tracking')
        }

        this.$message({
          message: 'Project Updated Successfully',
          type: 'success'
        })
      } catch (err) {
        this.$message({
          message: err.message ? `Project Update Error: ${err.message}` : 'Project Update Error',
          type: 'error'
        })
      }
    },
    getProcessName(processId) {
      return this.GET_VALUEFROMKEY('projectProcesses', processId)
    },
    showHistoryPopper(e, refName, row) {
      this.selectedTaskHistoryRows = []

      // copy the history and stick the current row in as the first history item
      // so that the popover displays current + all history
      const history = JSON.parse(JSON.stringify(row.taskHistory))
      history.unshift(row)

      this.selectedTaskHistoryTask = row.task

      for (let i = 0; i < history.length; i++) {
        const currentRow = history[i]
        const olderRow = history[i + 1]

        if (olderRow) {
          if (currentRow.isNA !== olderRow.isNA) {
            if (currentRow.isNA) {
              this.selectedTaskHistoryRows.push({
                event: 'N/A was checked',
                date: format(parseISO(currentRow.modifiedDate), 'M/d/yyyy hh:mm a'),
                user: this.getUserById(currentRow.modifiedBy)
              })
            } else {
              this.selectedTaskHistoryRows.push({
                event: 'N/A was unchecked',
                date: format(parseISO(currentRow.modifiedDate), 'M/d/yyyy hh:mm a'),
                user: this.getUserById(currentRow.modifiedBy)
              })
            }
          }

          if (currentRow.taskDate !== olderRow.taskDate) {
            this.selectedTaskHistoryRows.push({
              event: `Task Date was changed from ${olderRow.taskDate ? format(parseISO(olderRow.taskDate), 'M/d/yyyy') : 'blank'} to ${currentRow.taskDate ? format(parseISO(currentRow.taskDate), 'M/d/yyyy') : 'blank'}`,
              date: format(parseISO(currentRow.modifiedDate), 'M/d/yyyy hh:mm a'),
              user: this.getUserById(currentRow.modifiedBy)
            })
          }
        } else {
          if (currentRow.isNA) {
            this.selectedTaskHistoryRows.push({
              event: 'N/A was checked',
              date: format(parseISO(currentRow.modifiedDate), 'M/d/yyyy hh:mm a'),
              user: this.getUserById(currentRow.modifiedBy)
            })
          } else {
            this.selectedTaskHistoryRows.push({
              event: `Task Date was set to ${currentRow.taskDate ? format(parseISO(currentRow.taskDate), 'M/d/yyyy') : 'blank'}`,
              date: format(parseISO(currentRow.modifiedDate), 'M/d/yyyy hh:mm a'),
              user: this.getUserById(currentRow.modifiedBy)
            })
          }
        }
      }

      const popper = this.$refs[refName]
      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = e.target
        popper.doDestroy()
        popper.referenceElm = e.target
        this.isOpen = true
        popper.doShow()
      })
    },
    handleHidePopOver(ref) {
      const popper = this.$refs[ref]
      const handler = e => {
        if (e.target !== popper.$el) {
          popper.doDestroy()
          popper.doClose()
        }
        document.removeEventListener('click', handler, false)
      }
      document.addEventListener('click', handler, false)
    },
    statusSelectHideShow(show) {
      if (show) {
        this.backupStatusFilters = this.statusFilters
      } else {
        if (JSON.stringify(this.backupStatusFilters) !== JSON.stringify(this.statusFilters)) {
          this.handleTabClick()
        }
      }
    },
    statusSelectRemoveTag() {
      this.handleTabClick()
    },
    tagsSelectHideShow(show, project) {
      if (show) {
        this.backupIdentifierSelectionsArray = this.identifierSelectionsArray
      } else {
        if (JSON.stringify(this.backupIdentifierSelectionsArray) !== JSON.stringify(this.identifierSelectionsArray)) {
          this.identifiersOnChange(project)
        }
      }
    },
    tagsSelectRemoveTag(val, project) {
      this.identifiersOnChange(project)
    },
    identifiersOnChange(project) {
      project.identifierSelectionsArray.forEach(element => {
        // if element doesn't exist in, add it with add flag
        const matchedElements = project.identifierSelections.some(function(i) {
          return i.identifierID === element
        })
        if (!matchedElements) {
          const newValue = {
            id: 0,
            identifierID: element,
            add: true
          }

          project.identifierSelections.push(newValue)
        }
      })

      project.identifierSelections.forEach(element => {
        // if element doesn't exists in Array, set deleted flag
        if (!project.identifierSelectionsArray.includes(element.identifierID)) {
          element.delete = true
        }
      })

      this.updateProject(true)
    },
    putProjectId(event, field) {
      if (!event.target.value) {
        this.savePopoverContent = 'Project ID must always contain a value.'
        this.openSavePopover(event)
        event.target.value = this.project.projectID
        return false
      }
      this.project.projectID = event.target.value
      this.updateProject(field)
    },
    hideNucleusRebuttalDashboards() {
      let clientObj = this.clients.find(x => x.clientNumber === this.currentClient)
      return clientObj ? clientObj.hideNucleusRebuttalDashboards : false
    },
    openSavePopover(e) {
      if (!e) {
        return
      }

      const popper = this.$refs.savePopover

      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = e.target
        popper.doDestroy()
        popper.referenceElm = this.popperClickTarget
        this.isOpen = true
        popper.doShow()
      })
    },
    getReviewDashboardData() {
      let payload = {
        startDate: this.dateRange[0],
        endDate: this.dateRange[1],
        projects: this.selectedProjects,
        inpatientGrouping: this.inpatientGrouping,
        outpatientGrouping: this.outpatientGrouping,
        ambulatoryGrouping: this.ambulatoryGrouping,
        proGrouping: this.proGrouping
      }

      // this.loading = true
      this.POST_REVIEW_DASHBOARD_ALL(payload).then(() => {
        // this.loading = false
        // this.activeTabChanger()
      })

      // remove focus on button
      // event.target.blur()
    },
    hasMultiplePatTypes() {
      let counter = 0
      if (this.project.hasIPRecords) {
        this.singlePatTypeLabel = 'ip'
        counter++
      }
      if (this.project.hasOPRecords) {
        this.singlePatTypeLabel = 'op'
        counter++
      }
      if (this.project.hasAMBRecords) {
        this.singlePatTypeLabel = 'amb'
        counter++
      }
      if (this.project.hasPRORecords) {
        this.singlePatTypeLabel = 'pro'
        counter++
      }
      return counter
    },
    setActivePatientTab() {
      if (this.project.hasPRORecords) {
        this.activePatientTab = 'pro'
      }
      if (this.project.hasAMBRecords) {
        this.activePatientTab = 'amb'
      }
      if (this.project.hasOPRecords) {
        this.activePatientTab = 'op'
      }
      if (this.project.hasIPRecords) {
        this.activePatientTab = 'ip'
      }
    },
    handlePatientTabs(tab, event) {
      if (tab.name === 'ip') {
        this.$refs.ipList.$refs.coderReviewListGrid.getData()
      }
      if (tab.name === 'op') {
        this.$refs.opList.$refs.coderOutpatientListGrid.getData()
      }
      if (tab.name === 'amb') {
        this.$refs.ambList.$refs.coderOutpatientListGrid.getData()
      }
      if (tab.name === 'pro') {
        this.$refs.proList.$refs.coderProListGrid.getData()
      }
    },
    getRecordCount() {
      if (this.project.hasIPRecords) {
        return `- ${this.project.ipCount} Inpatient Records`
      }
      if (this.project.hasOPRecords) {
        return `- ${this.project.opCount} Outpatient Records`
      }
      if (this.project.hasAMBRecords) {
        return `- ${this.project.ambCount} Ambulatory Records`
      }
      if (this.project.hasPRORecords) {
        return `- ${this.project.proCount} Professional Fee Records`
      }
    },
    projectStatusMessage() {
      const status = this.project && this.project.reviewTimeLine.length
        ? this.project.reviewTimeLine[0].dataStatus
        : 'Not Started'
      return `${this.getProjectStatusLabel(status)} — no records available at this time`
    },
    isInProgress() {
      if (this.project && this.project.reviewTimeLine.length) {
        const status = this.project.reviewTimeLine[0].dataStatus
        return status === 'Not Started' || status === 'Project Ready' || status === 'In Progress'
      }
      return false
    }
  },
  // activated: function () {
  //   window.document.title = 'Projects'
  //   this.isActivated = true
  //   if (parseInt(this.$route.params.id) !== this.project.id) {
  //     this.initialize()
  //   } else {
  //     // may need to reset the project id in vuex in case it was cleared elsewhere
  //     this.SET_PROJECTPK(this.project.id)
  //   }
  // },
  deactivated: function() {
    this.loading = true
    this.deactivated = true
  },
  created: function() {
    this.initialize()
  },
  activated: function() {
    if (this.deactivated) {
      this.initialize()
    }
    this.deactivated = false
    console.log('active')
  },
  components: {
    coderProjectHeader,
    coderInpatientList,
    coderOutpatientList,
    coderAmbulatoryList,
    coderProList,
    ReviewDashboardInpatient,
    ReviewDashboardOutpatient,
    ReviewDashboardAmbulatory,
    ReviewDashboardProfee,
    rebuttalTracking,
    rebuttalTraining
  },
  computed: {
    ...mapState('myProjects/', ['ipListStatistics', 'opListStatistics', 'proListStatistics', 'ambListStatistics']),
    ...mapState('user/', ['currentClient', 'currentClientName', 'currentClientId', 'clients', 'user']),
    ...mapGetters('dropdowns', ['GET_VALUEFROMKEY']),
    ...mapState('inpatientReviews/', ['ipProjectStatistics']),
    ...mapState('outpatientReviews/', ['opProjectStatistics']),
    ...mapState('proReviews/', ['proProjectStatistics']),
    ...mapState('reports/', ['reports']),
    ...mapState('dropdowns/', ['dropdowns']),
    ...mapState('myProjects/', ['project', 'projectLoading', 'drgTableIds', 'proRecordIds', 'ascTableIds', 'ipList', 'opList', 'ambList', 'proList']),
    ...mapFields(['project.clientId', 'project.startDate', 'project.endDate', 'project.identifierId', 'project.coderId', 'project.id', 'project.projectID', 'project.projectTypeId', 'project.leadId', 'project.identifierSelectionsArray', 'project.identifierSelections', 'project.defaultCodeType', 'project.description', 'project.outpatientGrouperId', 'project.projectColor', 'project.projectStatusId', 'project.coderReviewedDate', 'project.providerReviewedDate', 'project.responseCompleteDate', 'project.appealAnsweredDate']),
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData', 'selectedProjects', 'inpatientGrouping', 'outpatientGrouping', 'proGrouping', 'ambulatoryGrouping']),
    compDashboardType() {
      if (this.project.projectTypeName === 'Inpatient') {
        return 'ip'
      }
      if (this.project.projectTypeName === 'Outpatient') {
        return 'op'
      }
      if (this.project.projectTypeName === 'Professional Fee') {
        return 'pro'
      }
      if (this.project.projectTypeName === 'Ambulatory') {
        return 'asc'
      }
      return null
    },
    compProjectStatistics() {
      if (this.project.projectTypeName === 'Inpatient') {
        return this.ipProjectStatistics
      }
      if (this.project.projectTypeName === 'Outpatient') {
        return this.opProjectStatistics
      }
      if (this.project.projectTypeName === 'Professional Fee') {
        return this.proProjectStatistics
      }
      if (this.project.projectTypeName === 'Ambulatory') {
        return this.opProjectStatistics
      }
      return {}
    }
  }
}
</script>

<style scoped>
#comments::placeholder {
  font-size: 12px;
  font-family: 'Roboto', sans-serif;
}

.projectButtons {
  margin-top: 40px;
}

.projectButtons button {
  margin-left: 10px;
}

>>> #ipSummaryTitle {
  display: none;
}

.multiSelect >>> .el-input__inner {
  min-height: 30px !important;
}

#taskTable >>> .VuePagination {
  display: none;
}

>>> .taskCol {
  width: 20%;
}

>>> .taskDateCol {
  width: 15%;
}

>>> .isNACol {
  width: 10%;
}

>>> .modifiedByCol {
  width: 20%;
}

>>> .modifiedDatecol {
  width: 20%;
}

@media screen and (max-width: 1310px) and (min-width: 0px) {
  >>> .taskCol {
    width: 25%;
  }

  >>> .taskDateCol {
    width: 25%;
  }

  >>> .isNACol {
    width: 20%;
  }

  >>> .modifiedByCol {
    width: 15%;
  }

  >>> .modifiedDatecol {
    width: 15%;
  }
}

>>> .dataCards {
  display: none;
}

>>> .tab .el-tabs__nav-wrap:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: #e4e7ed;
  z-index: 1;
  display: none;
}

>>> .patientTabs .el-tabs__item {
  text-align: left;
}

#projectLists >>> .tableOptions {
  display: none;
}

>>> .el-table .cell {
  word-break: normal;
}
</style>
